import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../useTable";
import { formatMoneda, diaSemana, validaSoloNumero } from "../../../../util/varios";
//UI
import { DangerButton, InfoButton, SuccessButton, WarningButton } from "../../../../ui/buttons/Button";
import { Input, Radio, Select } from "../../../../ui/inputs/Input";
import { height } from "@mui/system";
import { Dimmer } from "../../../spinner";
import { Mensaje } from "../../../mensajes2";
import moment from "moment";
import axios from "axios";
import ActualizarPeriodoNomina from "./actualizarPeriodoNomina";

const headCells = [
	{
		id: "numeroPeriodo",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Num. Periodo",
		textAlign: "center",
	},
	{
		id: "dia",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Día",
		textAlign: "center",
	},
	{
		id: "desde",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Desde",
		textAlign: "center",
	},
	{
		id: "dia2",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Día",
		textAlign: "center",
	},
	{
		id: "hasta",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Hasta",
		textAlign: "center",
	},
];

export default function TipoNomina(props) {
	var op = require('../../../../../src/modulos/datos');
	let token = localStorage.getItem('jwtToken');
	const [periodos, setPeriodos] = useState([]);
	const [deshabilitado, setDeshabilitado] = useState(true);
	const [deshabiBot, setDeshabiBot] = useState(true);
	const [filterFn, setFilterFn] = useState({ fn: (items) => { return items; }, });
	const [activate, setActivate] = useState(false);
	const [activo, setActivo] = useState(true);
	const [select, setSelect] = useState(false);
	const [mostrar, setMostrar] = useState(false)
	const [itemSelect, setItemSelect] = useState(-1);
	const [periodoSel, setPeriodoSel] = useState();
	const [operacionPer, setOperacionPer] = useState([]);
	const [mensaje, setMensaje] = useState({
		mostrar: false,
		titulo: "",
		texto: "",
		icono: "",
	});


	const txtCodNomina = useRef();
	const txtTituloNomina = useRef();
	const cmbStatus = useRef();
	const txtAnioCurso = useRef();
	const txtPeriodoDesde = useRef();
	const txtPeriodoHasta = useRef();
	const cmbSelecPeriodo = useRef();
	const txtNumPeriodo = useRef();
	const txtDesPeriodo = useRef();
	const cmbProximoPeriodo = useRef();
	const txtProximoPeriodo = useRef();
	const radioSi = useRef();
	const radioNo = useRef();
	const btnAcepta = useRef();
	const btnCancela = useRef();

	const { TblContainer,
		TblHead,
		recordsAfterPagingAndSorting,
		TblPagination
	} = useTable(periodos, headCells, filterFn);

	const salir = () => {
		blanquear();
		props.onHideCancela();
	};

	const handleSelectPeriodos = (event) => {
		event.preventDefault();
		if (event.target.value === "1") {
			txtNumPeriodo.current.value = "52";
			txtDesPeriodo.current.value = "SEMANAL";
			setDeshabilitado(true);
		} else if (event.target.value === "2") {
			txtNumPeriodo.current.value = "24";
			txtDesPeriodo.current.value = "QUINCENAL";
			setDeshabilitado(true);
		} else if (event.target.value === "3") {
			txtNumPeriodo.current.value = "12";
			txtDesPeriodo.current.value = "MENSUAL";
			setDeshabilitado(true);
		} else {
			txtNumPeriodo.current.value = "";
			txtDesPeriodo.current.value = "";
			setDeshabilitado(false);
		}
	}

	const handleSelectProximoPeriodo = (event) => {
		event.preventDefault();
		txtProximoPeriodo.current.value = "PERIODO Nº " + cmbProximoPeriodo.current.value +
			"  Desde: " + moment.utc(periodos[parseInt(cmbProximoPeriodo.current.value) - 1].fecini).format("DD/MM/YYYY")
			+ "  Hasta: " + moment.utc(periodos[parseInt(cmbProximoPeriodo.current.value) - 1].fecfin).format("DD/MM/YYYY");
	}

	const aceptar = () => {
		var sigue = true;
		if (txtCodNomina.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Código de la nomina no debe estar vacio.', icono: 'informacion' });
			sigue = false;
			txtCodNomina.current.focus();
		} else if (parseInt(txtCodNomina.current.value.trim()) === 0) {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Código de la nomina no debe ser cero.', icono: 'informacion' });
			sigue = false;
			txtCodNomina.current.focus();
		} else if (txtTituloNomina.current.value === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El titulo de la Nomina no deben estar vacio.', icono: 'informacion' });
			sigue = false;
			txtTituloNomina.current.focus();
		} else if (txtAnioCurso.current.value === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Año no deben estar vacio.', icono: 'informacion' });
			sigue = false;
			txtAnioCurso.current.focus();
		} else if (txtPeriodoDesde.current.value === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha de Inicio no es valida.', icono: 'informacion' });
			sigue = false;
			txtPeriodoDesde.current.focus();
		} else if (txtPeriodoHasta.current.value === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha de Fín no es valida.', icono: 'informacion' });
			sigue = false;
			txtPeriodoHasta.current.focus();
		} else if (txtPeriodoHasta.current.value <= txtPeriodoDesde.current.value) {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha de Fin (Hasta) no Puede ser Anterior o Igual a la Fecha de Inicio (Desde).', icono: 'informacion' });
			sigue = false;
			txtPeriodoDesde.current.focus();
		} else if (txtNumPeriodo.current.value === '' || parseInt(txtNumPeriodo.current.value.trim()) === 0) {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Número del Período no debe estar vacio o ser cero.', icono: 'informacion' });
			sigue = false;
			txtNumPeriodo.current.focus();
		} else if (txtDesPeriodo.current.value === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Descripción del Período no debe estar vacia.', icono: 'informacion' });
			sigue = false;
			txtDesPeriodo.current.focus();
		} else if (cmbProximoPeriodo.current.value === '' && props.operacion !== 1) {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El proximo Período no debe estar vacio.', icono: 'informacion' });
			sigue = false;
			cmbProximoPeriodo.current.focus();
		}

		if (sigue) {
			/*let data = [...records];
			for (let i = 0; i < data.length; i++) {
				data[i].montovaluacion = data[i].montovaluacion.replace(/\./g, "").replace(",", ".");
			}*/
			//let obj = JSON.parse(localStorage.getItem("post"));

			let body = {
				//operacion:props.operacion,
				codnomina: txtCodNomina.current.value,
				titnomina: txtTituloNomina.current.value,
				anio: parseInt(txtAnioCurso.current.value),
				fechaini: txtPeriodoDesde.current.value,
				fechafin: txtPeriodoHasta.current.value,
				numperiodo: parseInt(txtNumPeriodo.current.value),
				desperiodo: txtDesPeriodo.current.value.trim().toUpperCase(),
				properiodo: props.operacion === 1 ? 1 : parseInt(cmbProximoPeriodo.current.value),
				intecon: radioSi.current.checked,
				codviejo: txtCodNomina.current.value,
				tipoper: parseInt(cmbSelecPeriodo.current.value),
				nstatus: parseInt(cmbStatus.current.value),
				nomusu: JSON.parse(localStorage.getItem("post")).login,
				nomper: JSON.parse(localStorage.getItem('liquidador')),
				fechasis: JSON.parse(localStorage.getItem('fechasistema')),
				periodos: JSON.stringify(periodos)
			};
			//alert(JSON.stringify(body))
			actualizarNomina(body);
		}

	};

	const actualizarNomina = (body) => {
		setActivate(true);
		let endpoint = `${op.conexion}/api/nomina/actualizartiponomina/${props.operacion}`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				setActivate(false);
				if (response.status == 200) {
					if (response.data) {
						//setDesde(1);

						if (props.operacion !== 4) {
							if (JSON.parse(localStorage.getItem('codigonomina')) != null) {
								if (JSON.parse(localStorage.getItem('codigonomina')).trim() === txtCodNomina.current.value) {
									localStorage.setItem('numperiodo', JSON.stringify(cmbProximoPeriodo.current.value));
									localStorage.setItem('fechainiper', JSON.stringify(txtPeriodoDesde.current.value));
									localStorage.setItem('fechafinper', JSON.stringify(txtPeriodoHasta.current.value));
								}
							}
						}
						blanquear();
						if (props.operacion === 1) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Nomina " + response.data.valret + " ha sido creada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 2) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Nomina " + response.data.valret + " ha sido modificada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 3) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Nomina " + response.data.valret + " ha sido ha sido Eliminada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 4) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"Los Períodos de la Nomina " + response.data.valret + " han sido ha sido Actualizados de manera satisfactoria.",
								icono: "informacion",
							});
						}

					}
				}

			})
			.catch(function (error) {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const cerrarModal = () => {
		setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
		props.onHideCancela();
		props.onHideRenderizar()
	};

	const onChange = (event) => {
		event.preventDefault();
		if (
			event.target.name === "titulonomi" ||
			event.target.name === "descriper"
		) {
			event.target.value = event.target.value.toUpperCase();
			if (event.which === 13) {
				if (event.target.name === "titulonomi") {
					txtAnioCurso.current.focus();
				} else if (event.target.name === "descriper") {
					if (props.operacion === 1) {
						btnAcepta.current.focus();
					} else {
						cmbProximoPeriodo.current.focus();
					}

				}
			}
		}
	};

	const handleInputNumChange = (event) => {
		event.preventDefault();
		if (event.target.name === "codnomi" || event.target.name === "numperi" || event.target.name === "aniocurso") {
			validaSoloNumero(event);
		}

		if (event.which === 13 || typeof event.which === "undefined") {
			if (event.target.name === "codnomi") {
				txtCodNomina.current.value = event.target.value.trim().padStart(3, 0)
			}
			if (event.which === 13) {
				if (event.target.name === "codnomi") {
					txtTituloNomina.current.focus();
				} else if (event.target.name === "numperi") {
					txtDesPeriodo.current.focus();
				} else if (event.target.name === "aniocurso") {
					txtPeriodoDesde.current.focus();
				}
			}
		} else if (event.which === 46) {
			return false;
		} else if (event.which >= 48 && event.which <= 57) {
			return true;
		} else if (event.which === 8 || event.which === 0 || event.which === 44) {
			return true;
		} else return false;
	};

	const blanquear = () => {
		setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
		setItemSelect("");
		setActivate(false);
		setActivo(true);
		setPeriodos([]);
		setFilterFn({ fn: items => { return items; } });
	};

	const seleccionarFila = (index) => (event) => {
		setItemSelect(index);
		setActivo(false);
		setPeriodoSel(recordsAfterPagingAndSorting()[index]);
		//alert(JSON.stringify(recordsAfterPagingAndSorting()[index]))
		//setSelect(parseInt(nominaSel));
		/*var codigonomina = recordsAfterPagingAndSorting()[index].codnomi;
		var titulonomina = recordsAfterPagingAndSorting()[index].titnomi;
		var aniocurso = recordsAfterPagingAndSorting()[index].aniocurso;
		var numperiodo = recordsAfterPagingAndSorting()[index].proximo;
		var codigootropago = null;
		var titulotropago = null;

		var datos = [];
		datos.push({
			codigonomina,
			titulonomina,
			aniocurso,
			numperiodo,
			codigootropago,
			titulotropago
		})
		setValues(datos);*/
	};

	const aceptarCambioPeriodo = (nper, dfecini, dfecfin) => {
		setMostrar(false);
		var data = [...periodos];
		const data1 = data.find(
			a => a.numper === nper
		)

		data1.fecini = dfecini;
		data1.fecfin = dfecfin;
		setPeriodos(data);
		setDeshabiBot(false);
	};

	return (
		<Modal
			size="lg"
			{...props}
			aria-labelledby="contained-modal-title-vcenter"
			centered
			style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
			backdrop="static"
			keyboard={false}
			onShow={() => {
				if (props.operacion === 4) {
					setDeshabiBot(true);
				} else {
					setDeshabiBot(false);
				}

				if (props.operacion !== 1) {
					setPeriodos(props.periodos);
					txtCodNomina.current.value = props.nomina.codnomi;
					txtTituloNomina.current.value = props.nomina.titnomi.trim();
					cmbStatus.current.value = props.nomina.status;
					txtAnioCurso.current.value = props.nomina.aniocurso;
					txtPeriodoDesde.current.value = moment.utc(props.nomina.fecini).format("YYYY-MM-DD");
					txtPeriodoHasta.current.value = moment.utc(props.nomina.fecfin).format("YYYY-MM-DD");
					switch (props.nomina.numper) {
						case 52:
							cmbSelecPeriodo.current.value = "1";
							setDeshabilitado(true);
							break;
						case 24:
							cmbSelecPeriodo.current.value = "2";
							setDeshabilitado(true);
							break;
						case 12:
							cmbSelecPeriodo.current.value = "3";
							setDeshabilitado(true);
							break;
						default:
							cmbSelecPeriodo.current.value = "4";
							setDeshabilitado(false);
							break;
					}
					txtNumPeriodo.current.value = props.nomina.numper;
					txtDesPeriodo.current.value = props.nomina.desper;
					if (props.nomina.intecon) {
						radioSi.current.checked = true;
						radioNo.current.checked = false;
					} else {
						radioSi.current.checked = false;
						radioNo.current.checked = true;
					}
					setTimeout(() => {
						cmbProximoPeriodo.current.value = props.nomina.proper;
						txtProximoPeriodo.current.value = "PERIODO Nº " + props.nomina.proper +
							"  Desde: " + moment.utc(props.periodos[props.nomina.proper - 1].fecini).format("DD/MM/YYYY")
							+ "  Hasta: " + moment.utc(props.periodos[props.nomina.proper - 1].fecfin).format("DD/MM/YYYY");
					}, 500);


					txtTituloNomina.current.focus();
				} else {
					txtNumPeriodo.current.value = "52";
					txtDesPeriodo.current.value = "SEMANAL";
					setDeshabilitado(true);
					txtCodNomina.current.focus();
				}

			}}
		>
			<Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
				<h3 className="fw-bold m-0">Actulizar Tipos de Nomina</h3>
				<a type="button" className="fw-bold text-light fs-6" onClick={salir}>
					Salir <i className="fa fa-times ms-2"></i>
				</a>
			</Modal.Header>
			<Modal.Body className="col-12 m-0 p-2">
				<ul className="nav d-flex mb-2 flex-wrap gap-1 align-items-center" id="ex-with-icons" role="tablist">
					<li className="nav-item" role="presentation">
						<a
							className="nav-link active bg-blue-100 text-light rounded h-100"
							id="tipo-tab"
							data-bs-toggle="tab"
							data-bs-target="#tipo-tab-pane"
							type="button"
							role="tab"
							aria-controls="tipo-tab-pane"
							aria-selected="true"
						>
							Tipo Nomina
						</a>
					</li>
					<li class="nav-item" role="presentation">
						<a
							className="nav-link bg-blue-200 text-light rounded h-100"
							id="periodo-tab"
							data-bs-toggle="tab"
							data-bs-target="#periodo-tab-pane"
							type="button"
							role="tab"
							aria-controls="periodo-tab-pane"
							aria-selected="false"
							disabled={props.operacion === 1 ? true : false}
						>
							Períodos de la Nomina
						</a>
					</li>
				</ul>
				<div class="tab-content" id="myTabContent">
					<div
						class="tab-pane fade show active"
						id="tipo-tab-pane"
						role="tabpanel"
						aria-labelledby="tipo-tab"
						tabindex="0"
					>
						<form
							onSubmit={(e) => e.preventDefault()}
							className="col-12 m-0 p-0 d-flex flex-wrap"
						>
							<div className="col-12 m-0 mb-2 p-0">
								<div className="col-4 m-0 p-0">
									<Input label="Cod. Nomina:" readOnly={props.operacion === 1 ? false : true} ref={txtCodNomina} name="codnomi" onKeyUp={handleInputNumChange} />
								</div>
							</div>
							<div className="col-8 m-0 mb-2 p-0">
								<Input label="Titulo Nomina:" readOnly={props.operacion === 1 || props.operacion === 2 ? false : true} ref={txtTituloNomina} name="titulonomi" onKeyUp={onChange} />
							</div>
							<div className="col-4 m-0 mb-2 p-0 pl-2">
								<Select label="Status:" disabled={props.operacion === 1 || props.operacion === 2 ? false : true} ref={cmbStatus}>
									<option key="1" value="1">Activo</option>
									<option key="2" value="2">Inactivo</option>
								</Select>
							</div>
							<div className="col-4 m-0 p-0">
								<Input label="Año en Curso:" readOnly={props.operacion === 1 || props.operacion === 2 ? false : true} ref={txtAnioCurso} name="aniocurso" onKeyUp={handleInputNumChange} />
							</div>
							<fieldset className="col-12 m-0 mb-2 p-2 d-flex border-azul rounded">
								<legend className="float-none w-auto m-0">
									Periodo de la primera Nomina
								</legend>
								<div className="col-4 m-0 p-0">
									<Input type="date" label="Desde:" readOnly={props.operacion === 1 || props.operacion === 2 ? false : true} ref={txtPeriodoDesde} onKeyUp={(e) => { if (e.which === 13) { txtPeriodoHasta.current.focus() } }} />
								</div>
								<div className="col-4 m-0 p-0 pl-2">
									<Input type="date" label="Hasta:" readOnly={props.operacion === 1 || props.operacion === 2 ? false : true} ref={txtPeriodoHasta} onKeyUp={(e) => { if (e.which === 13) { cmbSelecPeriodo.current.focus() } }} />
								</div>
								<div className="col-4 m-0 p-0 pl-2">

								</div>
							</fieldset>
							<div className="col-9 m-0 mb-2 p-0">
								<Select label="Seleccionar Períodos:" disabled={props.operacion === 1 || props.operacion === 2 ? false : true} ref={cmbSelecPeriodo} onChange={handleSelectPeriodos} >
									<option key="1" value="1">Semanal(52)</option>
									<option key="2" value="2">Quincenal(24)</option>
									<option key="3" value="3">Mensual(12)</option>
									<option key="4" value="4">Otros(1-365)</option>
								</Select>
							</div>
							<div className="col-3 m-0 p-0 pl-2"></div>
							<div className="col-7 m-0 p-0">
								<Input label="Num. Períodos:" readOnly={deshabilitado} ref={txtNumPeriodo} name="numperi" onKeyUp={handleInputNumChange} />
							</div>
							<div className="col-5 m-0 p-0 pl-2"></div>
							<div className="col-9 m-0 p-0">
								<Input label="Des. Períodos:" readOnly={deshabilitado} ref={txtDesPeriodo} name="descriper" onKeyUp={onChange} />
							</div>
							<div className="col-3 m-0 p-0 pl-2"></div>
							<div className="col-12 m-0 p-0 d-flex gap-2">
								<div className="col-10 m-0 p-0">
									<Input label="Proximo Período:" readOnly ref={txtProximoPeriodo} />
								</div>
								<div className="col m-0 p-0">
									<Select disabled={props.operacion === 2 ? false : true} ref={cmbProximoPeriodo} onChange={handleSelectProximoPeriodo}>
										{periodos && periodos.map(p => (
											<option key={p.numper} value={p.numper}>{p.numper}</option>
										))}
									</Select>
								</div>
							</div>
							<div className="col-auto m-0 p-0 d-flex gap-2">
								<span className="fw-bold">Integración con Presupuesto:</span>
								<div className="col-auto m-0 p-0">
									<Radio label='Si' name='integracion' id='integracion1' ref={radioSi} />
								</div>
								<div className="col-auto m-0 p-0">
									<Radio label='No' name='integracion' id='integracion2' defaultChecked ref={radioNo} />
								</div>
							</div>
						</form>
					</div>
					<div
						class="tab-pane fade"
						id="periodo-tab-pane"
						role="tabpanel"
						aria-labelledby="periodo-tab"
						tabindex="0"
					>
						<div className="col-12 m-0 p-0 d-flex">
							<div className="col-11 m-0 p-0">
								<TblContainer>
									<TblHead />
									<tbody>
										{periodos &&
											recordsAfterPagingAndSorting().map((item, index) => (
												<tr key={item.numper} style={{ padding: "0", cursor: 'pointer', backgroundColor: select === parseInt(item.codnomi) ? "lightskyblue" : itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
													<td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.numper}</td>
													<td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{diaSemana(new Date(item.fecini).getDay())}</td>
													<td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{moment.utc(item.fecini).format('DD/MM/YYYY')}</td>
													<td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{diaSemana(new Date(item.fecfin).getDay())}</td>
													<td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{moment.utc(item.fecfin).format('DD/MM/YYYY')}</td>
												</tr>
											))}
									</tbody>
								</TblContainer>
								<TblPagination />
							</div>
							<div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
								<div className="col-auto m-0 p-0">
									<InfoButton onClick={() => { setOperacionPer(4); setMostrar(true); }} icon='fa-eye m-0' disabled={props.operacion === 4 ? activo : true} />
								</div>
								<div className="col-auto m-0 p-0">
									<WarningButton onClick={() => { setOperacionPer(2); setMostrar(true); }} icon='fa-edit m-0' disabled={props.operacion === 4 ? activo : true} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<SuccessButton disabled={props.operacion !== 4 ? false : deshabiBot} ref={btnAcepta} onClick={aceptar}>Aceptar</SuccessButton>
				<DangerButton ref={btnCancela} onClick={salir}>Cancelar</DangerButton>
			</Modal.Footer>
			<Dimmer active={activate} inverted>
			</Dimmer>
			<Mensaje
				mensaje={mensaje}
				onHide={() => {
					mensaje.titulo === "Exito."
						? cerrarModal()
						: setMensaje({
							mostrar: false,
							titulo: "",
							texto: "",
							icono: "",
						});
				}}
			/>
			<ActualizarPeriodoNomina
				show={mostrar}
				onHideCancela={() => setMostrar(false)}
				onHideAcepta={aceptarCambioPeriodo}
				operacion={operacionPer}
				periodo={periodoSel}
			/>
		</Modal>
	);
}
